import { RadioGroup } from "@rawa/ui/RadioGroup"
import { fieldInstructions, fieldName } from "../fields"
import type { ControlRenderer } from "./types"

// The value is the chosen option's value: its identity, and what anything
// reading the data gets.
export const radioGroup: ControlRenderer<"radioGroup"> = {
  Render: ({ field, value, onChange, error }) => (
    <RadioGroup
      id={field.id}
      label={fieldName(field)}
      hint={fieldInstructions(field)}
      value={value ?? ""}
      onChange={onChange}
      options={field.options.map((option) => ({
        value: option.value,
        label: option.label,
      }))}
      required={field.required}
      error={error}
    />
  ),
}
